import { NgxExcelModelColumnRule, NgxExcelColumnType, NgxExcelModelColumnRules } from '../models/models';
import { INgxExcelDataSource } from './ngx-excel-data-source';
import { Observable, of, throwError } from 'rxjs';
import { delay } from 'rxjs/operators';

export abstract class NgxExcelDataService<T> extends INgxExcelDataSource<T> {

  protected dataSet: T[] = [];
  protected rules: { [name in keyof T]: NgxExcelModelColumnRule<T> };
  protected additionalRules: { [name in keyof T]?: NgxExcelModelColumnRule<T> };
  protected metas: { [name: string]: any } = {}; // å·²è¢«ç¼å­çåæ°æ®

  /**
   * @inheritdoc
   */
  public getRule(name: string): NgxExcelModelColumnRule<T> {
    const rules = this.getRules();
    return rules[name] || null;
  }

  /**
   * è·å¾ææå­æ®µçæ¨¡åè§å
   */
  public getRules(): NgxExcelModelColumnRules<T> {
    if (!this.rules) {
      throw new Error('éææ°æ®æºçå­æ®µå®ä¹ç¼ºå¤±');
    }
    this.rules = Object.assign({}, this.rules, this.additionalRules || {});
    Object.keys(this.rules).forEach((ruleKey) => {
      this.rules[ruleKey].name = this.rules[ruleKey].name || ruleKey;
    });
    return this.rules;
  }

  /**
   * @inheritdoc
   */
  public getPrimaryKey(model: T): string {
    const rules = this.getRules();
    const rule = Object.entries<NgxExcelModelColumnRule<T>>(rules).find((entry) => entry[1].columnType === NgxExcelColumnType.PrimaryKey);
    return model[rule[0]] || '';
  }

  /**
   * @inheritdoc
   */
  public getResponseMetas(): { [name: string]: any } {
    return this.metas;
  }

  /**
   * @inheritdoc
   */
  public getList(filters?: { [name: string]: string | string[] }, page?: number, pageSize?: number): Observable<T[]> {
    const resultSet = this.dataSet.filter((data) => this.match(data, filters));
    this.metas = { total: resultSet.length };
    const list = page && pageSize ? resultSet.slice((page - 1) * pageSize, page * pageSize) : resultSet;
    return of(list).pipe(delay(500));
  }

  /**
   * ç»å®æ°æ®é
   * @param dataSet æ°æ®é
   */
  public bindDataSet(dataSet: T[]) {
    this.dataSet = dataSet;
  }

  /**
   * è·å¾å¨éæ°æ®é
   */
  public getDataSet(): T[] {
    return this.dataSet;
  }

  /**
   * æ´æ°æåå»ºå®ä¾æ¨¡å
   * @param payload è¯·æ±åæ°ææ¨¡åå¯¹è±¡
   * @param primaryKey æ¨¡åä¸»é®(å¦æä¾ä¸»é®ä»£è¡¨æ´æ°æ¨¡å, å¦ååå»ºæ¨¡å)
   */
  public save(payload: { [name: string]: any }, primaryKey?: string): Observable<T> {
    if (primaryKey === null || primaryKey === undefined) {
      return throwError(new Error('éææ°æ®æå¡ä¸åè®¸èªå¨æ°å¢æ°æ®è¡'));
    }

    const data = this.dataSet.find((item) => this.getPrimaryKey(item) === primaryKey);
    if (data) {
      Object.assign(data, payload);
    }

    return of(data);
  }

  /**
   * å¤æ­æ¨¡åæ¯å¦æ»¡è¶³æ¡ä»¶
   * @param model å¾å¤æ­çæ¨¡å
   * @param filters æ¡ä»¶
   */
  protected match(model: T, filters?: { [name: string]: string | string[] }) {
    return true;
  }

}
